import { sanitiseUrlForEnvironment, trimTrailingSlash, useLocalisedLink, useTenant } from '@parcel2go/npm-p2g-app';
import { useMemo } from 'react';
import { PAYMENT_PATH } from '~/lib/constants';
import { TenantSettingKeys } from '~/lib/consts/tenant-setting-keys';

export function usePaymentPath() {
  const { settings } = useTenant();
  const { swap } = useLocalisedLink();

  const paymentPath = useMemo(() => {
    const baseUrl = trimTrailingSlash(settings[TenantSettingKeys.Website] || '');
    if (settings['UI-SERVERLESS.PUBLIC.ORDERPROCESS.PAYMENTSENABLED'] === 'true') {
      return swap(sanitiseUrlForEnvironment(`${baseUrl}${PAYMENT_PATH}`));
    } else {
      return swap(sanitiseUrlForEnvironment(`${baseUrl}/order/payment`));
    }
  }, [settings, swap]);

  return paymentPath;
}
